export default __webpack_public_path__ + "static/media/2--240.df18e3d8.jpg";